import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HelperTagsPayload, HelperTagsSliceState } from '@/domains/helperTags/types/helperTagsTypes';

export const helperTagsInitialState: HelperTagsSliceState = {
  helperTagsPerEntity: {},
};

const helperTagsSlice = createSlice({
  name: 'helperTags',
  initialState: helperTagsInitialState,
  reducers: {
    getHelperTagsByEntity: (_, _action: PayloadAction<string>) => {},
    getHelperTagsByEntitySuccess: (state, { payload }: PayloadAction<HelperTagsPayload>) => {
      const { entityType, options } = payload;
      state.helperTagsPerEntity[entityType] = options;
    },
  },
});

export const { getHelperTagsByEntity, getHelperTagsByEntitySuccess } = helperTagsSlice.actions;

export const helperTagsReducer = helperTagsSlice.reducer;
export const helperTagsReducerPath = helperTagsSlice.reducerPath;
